/*
    @author: K Sai Prakash
    @service: google recaptcha v2 invisible service
    @published: 23-04-2020
    @description: To call the backend service to validate the response key received in the front end
*/
/** Angular dependencies */
import { Injectable } from '@angular/core';

/** In App dependencies */
import {  CURRENT_ENVIROMENT, SERVICE_END_POINT } from '../../../shared';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
  export class GoogleRecaptchaV2Service {
    private httpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' })
      };

    private endPoints = SERVICE_END_POINT[CURRENT_ENVIROMENT.environment];

    constructor(private http: HttpClient, private router: Router) { }

    getGoogleRecaptchaResponse(grecaptchaResponseKey: string): Observable<any> {
            if (CURRENT_ENVIROMENT.environment === 'localEnvironment') {
              return this.http.get<any>(this.endPoints.googleRecaptchaV2Url).pipe(
                map((res: Response) => {
                return res['success'];
              })
              )
            } else {
                return this.http.post<any>(this.endPoints.googleRecaptchaV2Url, grecaptchaResponseKey, this.httpOptions)
                .pipe(
                    map((res: Response) => {
                     return res['success'];
                    })
                )
            }
    }

}
